import React from 'react';
import { ToastItem } from '../contexts/ToastContext';
import './ToastContainer.css';

interface Props {
  toasts: ToastItem[];
  onClose: (id: number) => void;
}

const ToastContainer: React.FC<Props> = ({ toasts, onClose }) => {
  return (
    <div className="toast-container" aria-live="polite" aria-atomic="true">
      {toasts.map(toast => (
        <Toast key={toast.id} toast={toast} onClose={onClose} />
      ))}
    </div>
  );
};

const Toast: React.FC<{ toast: ToastItem; onClose: (id: number) => void }> = ({ toast, onClose }) => {
  React.useEffect(() => {
    const timer = setTimeout(() => onClose(toast.id), toast.durationMs);
    return () => clearTimeout(timer);
  }, [toast.durationMs, toast.id, onClose]);

  return (
    <div className={`toast-item toast-${toast.type}`} role="status">
      <span>{toast.message}</span>
      <button
        type="button"
        className="toast-close"
        onClick={() => onClose(toast.id)}
        aria-label="알림 닫기"
      >
        ×
      </button>
    </div>
  );
};

export default ToastContainer;

